var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadFileFilled = function SvgDownloadFileFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.8 11.817-2.217 2.216a.82.82 0 0 1-.583.242.834.834 0 0 1-.583-.242L7.2 11.817a.629.629 0 0 1 0-.884.629.629 0 0 1 .883 0l1.292 1.292V8.433A.63.63 0 0 1 10 7.808a.63.63 0 0 1 .625.625v3.792l1.292-1.292a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .884Zm3.892-5.534-3.809-3.808a.624.624 0 0 0-.441-.183H4.167c-.575 0-1.042.466-1.042 1.041v13.334c0 .575.467 1.041 1.042 1.041h11.666c.575 0 1.042-.466 1.042-1.041V6.725a.625.625 0 0 0-.183-.442Zm-3.884.442a.36.36 0 0 1-.366-.367V3.392l3.333 3.333h-2.967Z",
    fill: "current"
  })));
};
export default SvgDownloadFileFilled;